import * as React from 'react';

import { IconWrapper, ItemText, SocialItemLink } from './socialItem.styles';

type SocialItemProps = {
  icon: React.ReactNode;
  text: string;
  link: string;
};

export const SocialItem = ({ icon, link, text }: SocialItemProps) => (
  <SocialItemLink
    href={link}
    aria-label="Behance"
    rel="noopener noreferrer"
    target="_blank"
    className="what-we-have-built__socials-card what-we-have-built__behance"
  >
    <IconWrapper>{icon}</IconWrapper>
    <ItemText>on {text}</ItemText>
  </SocialItemLink>
);
